<div mat-dialog-title style="margin:0px; color: #A20000; text-align: center;">
    <span>ACCESS DENIED</span>
    <div *ngIf="noGradingType" style="font-size:14px;">
        <span>Grading Type has not been assigned to this class</span>
    </div>
    <div *ngIf="noGradingScale" style="font-size:14px;">
        <span>Grading Scale has not been assigned to this class</span>
    </div>
</div>

<mat-dialog-content>
    <div style="padding-bottom:10px;">
        <span>
            This Gradebook cannot be used until a Grading Type and Grading Scale has been assigned to this class.
        </span>
    </div>

    <div>
        <span>
            Please contact your gradebook administrator.
        </span>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button id="noAccessGradebookButton" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>